import { useI18n } from '@change-corgi/core/react/i18n';

import { useMembershipModalState } from '../../../../modalContext';
import { getAverageAmount, getAverageAmountExperimentVariant } from '../../../../shared/utils/averageAmountExperiment';

type Result = ModelHookResult<{
	display: boolean;
	variant: string;
	localizedAverageAmount: string;
}>;
export const useAverageAmountMessage = (): Result => {
	const [{ ppmuAverageAmountExperiment, currencyCode }] = useMembershipModalState();
	const { localizeCurrency } = useI18n();
	const variant = getAverageAmountExperimentVariant(ppmuAverageAmountExperiment);
	const averageAmount = getAverageAmount(ppmuAverageAmountExperiment);

	return {
		data: {
			display: variant === 'variant_2' || variant === 'variant_3',
			variant,
			localizedAverageAmount: averageAmount ? localizeCurrency(averageAmount, currencyCode) : '',
		},
	};
};
